/* Skapad av Claude Code — svd-productblock-bundle */
(function () {
  'use strict';

  // ============== Helpers ==============
  // Andra valutor än SEK (t.ex. EUR på FI): formatera som butikens money-filter. Mönstret läses ur
  // pickerns data-money-sample (= 123400 öre/cent genom Liquids money-filter, t.ex. "€1.234,00").
  var svdMoneyPattern = null;
  function svdMoneyFromSample(cents) {
    if (svdMoneyPattern === null) {
      svdMoneyPattern = false;
      var el = document.querySelector('[data-svd-picker][data-money-sample]');
      var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      var sample = el && el.getAttribute('data-money-sample');
      var m = sample && cur && cur !== 'SEK' ? sample.match(/1(\D?)234(?:(\D)00)?/) : null;
      if (m) svdMoneyPattern = { pre: sample.slice(0, m.index), post: sample.slice(m.index + m[0].length), th: m[1] || '', dec: m[2] || '' };
    }
    if (!svdMoneyPattern) return null;
    var p = svdMoneyPattern;
    var units = p.dec ? Math.floor(Math.round(cents) / 100) : Math.round(cents / 100);
    var whole = String(units).replace(/\B(?=(\d{3})+(?!\d))/g, p.th);
    var frac = p.dec ? p.dec + String(Math.round(cents) % 100).padStart(2, '0') : '';
    return p.pre + whole + frac + p.post;
  }

  function fmtMoneyKr(cents) {
    // Shopify prices är i cents (öre). Visa avrundat till hela kronor (rent).
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    var other = svdMoneyFromSample(cents);
    if (other) return other;
    return Math.round(cents / 100).toString() + ' kr';
  }

  // Marknadens språkrot (/fi-fi/ på FI, / på SE) – korgsvaret får då rätt språk (notisens produktnamn).
  function svdRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getDataNumber(el, key) {
    var raw = el && el.getAttribute('data-' + key);
    if (!raw) return 0;
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  // ============== Cart drawer-appen UpCart ==============
  // Butiken kör UpCart som själv fångar /cart/add-anrop och öppnar sin
  // egen drawer. När UpCart finns ska temats inbyggda drawer INTE öppnas
  // (annars visas båda ovanpå varandra) — bara cart-bubblan uppdateras.
  function hasUpCart() {
    return !!(window.upcart || document.querySelector('[id*="upcart" i], [class*="upcart" i]'));
  }

  function tryOpenUpCart() {
    try {
      if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; }
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); }
    } catch (e) { /* UpCart auto-öppnar normalt själv — detta är bara backup */ }
  }

  // ============== Temats cart drawer (Vision 2024) ==============
  // Speglar renderContents() i temats app.js: byt ut drawer + cart-bubble
  // med sections från add-svaret och öppna #Cart-Drawer med .active.
  var DRAWER_SECTIONS = [
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function sectionInnerHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderDrawerSections(response) {
    if (!response || !response.sections) return;
    DRAWER_SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = response.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var inner = sectionInnerHTML(html, s.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    if (typeof window.CartDrawer !== 'undefined') {
      new window.CartDrawer();
    }
  }

  function openThemeCartDrawer(response) {
    var drawerEl = document.getElementById('Cart-Drawer');
    if (!drawerEl) return false;

    renderDrawerSections(response);

    document.body.classList.add('open-cc');
    drawerEl.classList.add('active');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    return true;
  }

  // ============== Bundle Controller ==============
  function initBundle(root) {
    if (root.__svdBundleInit) return;
    root.__svdBundleInit = true;

    var weightSelect    = root.querySelector('[data-bundle-weight-select]');
    var weightButtons   = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-weight]'));
    var emptyEl         = root.querySelector('[data-bundle-empty]');
    var variantsEl      = root.querySelector('[data-bundle-variants]');
    var variants        = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-variant]'));
    var upsells         = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-upsell-for]'));

    // PostHog (SMILE 2026-10-28): samma mönster som varukorgens svd_cart_block, eget eventnamn för produktsidan.
    function track(block, action, extra) {
      try {
        if (!window.posthog || typeof window.posthog.capture !== 'function') return;
        var payload = { block: block, action: action, handle: root.getAttribute('data-product-handle') || '' };
        for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) payload[k] = extra[k]; }
        window.posthog.capture('svd_pdp_block', payload);
      } catch (e) {}
    }
    var cta             = root.querySelector('[data-bundle-cta]');
    var ctaPrices       = root.querySelector('[data-bundle-cta-prices]');
    var ctaNow          = root.querySelector('[data-bundle-cta-now]');
    var ctaWas          = root.querySelector('[data-bundle-cta-was]');
    var ctaLabel        = root.querySelector('[data-bundle-cta-label]');
    var modeGroup       = root.querySelector('[data-bundle-mode-group]');
    var modeButtons     = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-mode]'));

    // Prenumeration aktiverad? Selling_plan väljs per variant×vikt via data-plan-w* på varje rad.
    var subscriptionEnabled = root.getAttribute('data-subscription-enabled') !== 'false';

    if ((!weightSelect && weightButtons.length === 0) || !variantsEl || !cta || variants.length === 0) return;

    var state = {
      weightKey: '', // '', 'w1', 'w2', 'w3'
      selectedRow: null,
      mode: subscriptionEnabled ? (root.getAttribute('data-bundle-mode') || 'subscription') : 'onetime',
      plan: null     // selling_plan-ID (sträng) för vald variant×vikt, eller null
    };

    // Initial selected variant från data-selected="true"
    var initialSelected = variants.find(function (v) { return v.getAttribute('data-selected') === 'true'; });
    if (initialSelected) {
      state.selectedRow = initialSelected;
    } else if (variants[0]) {
      state.selectedRow = variants[0];
      variants[0].setAttribute('data-selected', 'true');
    }

    // Aktivt pris per variant: prenumerationspris i prenumerationsläge, annars engångspris
    function activePrice(v) {
      return (state.mode === 'subscription' && subscriptionEnabled)
        ? getDataNumber(v, 'sub-price')
        : getDataNumber(v, 'price');
    }

    // ============== Render days + per-month + per-rad pris ==============
    function renderDays() {
      var w = state.weightKey;
      variants.forEach(function (v) {
        var days = getDataNumber(v, 'days-' + w);
        var price = activePrice(v); // cents — byter mellan engångs-/prenumerationspris
        var daysEls = v.querySelectorAll('[data-bundle-days]');
        daysEls.forEach(function (el) {
          el.textContent = days > 0 ? String(days) : '—';
        });

        // Per-rad totalpris (server-renderat som engångspris; JS byter efter läge).
        var nowEl = v.querySelector('[data-bundle-total-now]');
        if (nowEl) nowEl.textContent = fmtMoneyKr(price);

        // Per-rad överstruket pris: prenumeration -> engångspriset överstruket (visar
        // 15%-besparingen, även på 150g som saknar compare_at); engångsläge -> compare_at
        // om varianten har en ordinarie rabatt.
        var wasEl = v.querySelector('[data-bundle-total-was]');
        if (wasEl) {
          // Överstruket = produktens jämförelsepris (compare_at; fallback engångspris om compare
          // saknas). Samma i båda lägena -> i prenumeration visas besparingen mot ordinariepriset.
          var refPrice = getDataNumber(v, 'compare-price');
          if (refPrice > price) { wasEl.textContent = fmtMoneyKr(refPrice); wasEl.hidden = false; }
          else { wasEl.hidden = true; }
        }
      });
    }

    // ============== Prenumeration: plan-val (variant×vikt) + cadence ==============
    function applySnap() {
      // Selling_plan för vald variant + vikt (9-cells-modell). Tom cell → null (engångs).
      var sel = state.selectedRow;
      var planId = sel ? (sel.getAttribute('data-plan-' + state.weightKey) || '').trim() : '';
      state.plan = (state.mode === 'subscription' && subscriptionEnabled && planId) ? planId : null;
      renderCadence();
    }

    function renderCadence() {
      // Per rad: "Leverans var X:e dag" = radens varaktighet (= intervallet planen satts till)
      variants.forEach(function (v) {
        var cadEl = v.querySelector('[data-bundle-cadence]');
        if (!cadEl) return;
        var days = getDataNumber(v, 'days-' + state.weightKey);
        cadEl.textContent = days > 0 ? String(days) : '—';
      });
    }

    // ============== Selection ==============
    function selectVariant(row) {
      state.selectedRow = row;
      variants.forEach(function (v) {
        var isSel = v === row;
        v.setAttribute('data-selected', isSel ? 'true' : 'false');
        var radio = v.querySelector('[data-bundle-radio]');
        if (radio) radio.checked = isSel;
      });
      // Antalsläget (svd-bundle--fold): av korten med gåvorutor är bara ett utfällt. Väljs ett
      // sådant kort fälls det ut och de andra ihop; väljs ett kort utan rutor (1 st) rörs inget.
      if (row && root.classList.contains('svd-bundle--fold') && row.querySelector('.svd-bundle__gwps')) {
        variants.forEach(function (v) {
          if (!v.querySelector('.svd-bundle__gwps')) return;
          if (v === row) v.removeAttribute('data-fold'); else v.setAttribute('data-fold', 'closed');
        });
      } else if (row && root.hasAttribute('data-fold-reset')) {
        // Paketkort (SMILE): kort utan rutor valt → det förvalda paketet fälls ut, övriga ihop.
        var defIdx = root.getAttribute('data-default-index');
        variants.forEach(function (v) {
          if (!v.querySelector('.svd-bundle__gwps')) return;
          if (v.getAttribute('data-variant-index') === defIdx) v.removeAttribute('data-fold'); else v.setAttribute('data-fold', 'closed');
        });
      }
      // Minsta storleken vald? (variant index 1 = första/minsta) -> CSS döljer [data-hide-smallest]
      root.setAttribute('data-smallest-selected', (row && row.getAttribute('data-variant-index') === '1') ? 'true' : 'false');
      // Uppgraderingsbanner: syns bara under sitt kort när det kortet är valt (visning räknas en gång per sidladdning).
      upsells.forEach(function (b) {
        var on = !!row && b.getAttribute('data-bundle-upsell-for') === row.getAttribute('data-variant-index');
        b.hidden = !on;
        if (on && !b._svdSeen) {
          b._svdSeen = true;
          track('upgrade_banner', 'view', { from: Number(b.getAttribute('data-bundle-upsell-for')), to: Number(b.getAttribute('data-bundle-upsell-target')) });
        }
      });
      applySnap();
      renderCta();
    }

    // ============== CTA total + state (läge-medveten) ==============
    function renderCta() {
      // Etikett efter läge
      if (ctaLabel) {
        var lblSub = cta.getAttribute('data-cta-label-subscription');
        var lblOne = cta.getAttribute('data-cta-label-onetime');
        var lbl = (state.mode === 'subscription' && subscriptionEnabled) ? lblSub : lblOne;
        if (lbl) ctaLabel.textContent = lbl;
      }

      var hasWeight = !!state.weightKey;
      if (!hasWeight) {
        cta.setAttribute('disabled', 'disabled');
        if (ctaPrices) ctaPrices.hidden = true;
        return;
      }
      cta.removeAttribute('disabled');

      var sel = state.selectedRow;
      if (!sel) {
        if (ctaPrices) ctaPrices.hidden = true;
        return;
      }

      // Slutsåld vald rad (t.ex. när hela produkten är slut): knappen stängs av och
      // säger "Slutsåld" (badgens översatta text), som temats vanliga köpknapp.
      if (sel.getAttribute('data-available') === 'false') {
        var soldEl = sel.querySelector('[data-svd-soldout]');
        if (ctaLabel && soldEl) ctaLabel.textContent = soldEl.textContent;
        cta.setAttribute('disabled', 'disabled');
        if (ctaPrices) ctaPrices.hidden = true;
        return;
      }

      var price = activePrice(sel);
      // Överstruket = produktens jämförelsepris (compare_at) i båda lägena.
      var compare = getDataNumber(sel, 'compare-price');

      // Lägg till checked addons i totalen (alltid engångspris — addons prenumereras ej)
      var addonNow = 0;
      var addonWas = 0;
      (typeof addons !== 'undefined' ? addons : []).forEach(function (a) {
        if (a.getAttribute('data-checked') === 'true') {
          addonNow += getDataNumber(a, 'addon-price');
          addonWas += getDataNumber(a, 'addon-compare');
        }
      });

      var totalNow = price + addonNow;
      var totalWas = compare + addonWas;

      if (ctaNow) ctaNow.textContent = fmtMoneyKr(totalNow);

      if (ctaWas) {
        if (totalWas > totalNow) {
          ctaWas.textContent = fmtMoneyKr(totalWas);
          ctaWas.hidden = false;
        } else {
          ctaWas.hidden = true;
        }
      }
      if (ctaPrices) ctaPrices.hidden = false;
    }

    // ============== Reveal variants on weight pick ==============
    function setWeight(key) {
      state.weightKey = key || '';
      if (state.weightKey) {
        if (emptyEl) emptyEl.hidden = true;
        variantsEl.hidden = false;
      } else {
        if (emptyEl) emptyEl.hidden = false;
        variantsEl.hidden = true;
      }
      // Update weight-button aria-checked
      weightButtons.forEach(function (btn) {
        btn.setAttribute('aria-checked', btn.getAttribute('data-bundle-weight') === state.weightKey ? 'true' : 'false');
      });
      // Köpval-växlaren: synlig när prenumeration finns, aktiv först när vikt valts (speglar CTA)
      if (modeGroup) {
        if (subscriptionEnabled) {
          modeGroup.hidden = false;
          modeButtons.forEach(function (b) { b.disabled = !state.weightKey; });
        } else {
          modeGroup.hidden = true;
        }
      }
      renderDays();
      applySnap();
      renderCta();
    }
    function onWeightChange() {
      setWeight(weightSelect ? weightSelect.value : '');
    }

    // ============== Köpläge: prenumeration / engångsköp ==============
    function setMode(mode) {
      if (mode !== 'subscription' && mode !== 'onetime') return;
      if (mode === 'subscription' && !subscriptionEnabled) mode = 'onetime';
      state.mode = mode;
      root.setAttribute('data-bundle-mode', mode); // CSS döljer [data-sub-only] i engångsläge
      // Paketkort (data-onetime-only) döljs i prenumerationsläget – var ett sådant valt byts valet till förvalt kort.
      if (mode === 'subscription' && state.selectedRow && state.selectedRow.hasAttribute('data-onetime-only')) {
        var defIdx = root.getAttribute('data-default-index');
        var fallback = variants.find(function (v) { return v.getAttribute('data-variant-index') === defIdx && !v.hasAttribute('data-onetime-only'); })
          || variants.find(function (v) { return !v.hasAttribute('data-onetime-only'); });
        if (fallback) selectVariant(fallback);
      }
      modeButtons.forEach(function (btn) {
        var on = btn.getAttribute('data-bundle-mode') === mode;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      renderDays();  // priser byter mellan engångs-/prenumerationspris
      applySnap();   // cadence + snappad plan för varukorgen
      renderCta();   // total + etikett efter läge
    }

    // ============== Add-ons (rabatterade tillbehör) ==============
    var addonsToggle = root.querySelector('[data-bundle-addons-toggle]');
    var addonsBody   = root.querySelector('[data-bundle-addons-body]');
    var addons       = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-addon]'));

    if (addonsToggle && addonsBody) {
      addonsToggle.addEventListener('click', function () {
        var open = addonsToggle.getAttribute('aria-pressed') === 'true';
        addonsToggle.setAttribute('aria-pressed', open ? 'false' : 'true');
        addonsBody.setAttribute('data-open', open ? 'false' : 'true');
      });
    }

    addons.forEach(function (addon) {
      addon.addEventListener('click', function (e) {
        // Förhindra navigation från "Läs mer"-länken
        if (e.target.classList.contains('svd-bundle__addon-more')) return;
        e.preventDefault();
        var checked = addon.getAttribute('data-checked') === 'true';
        addon.setAttribute('data-checked', checked ? 'false' : 'true');
        var input = addon.querySelector('[data-bundle-addon-check]');
        if (input) input.checked = !checked;
        renderCta();
      });
    });

    function getCheckedAddonIds() {
      return addons
        .filter(function (a) { return a.getAttribute('data-checked') === 'true'; })
        .map(function (a) { return parseInt(a.getAttribute('data-addon-id'), 10); })
        .filter(function (id) { return !isNaN(id) && id > 0; });
    }

    // Rabattkoder för ibockade tillbehör: per tillbehör i första hand,
    // blockets gemensamma kod som fallback. Dubbletter rensas.
    function getCheckedAddonDiscountCodes() {
      var globalCode = (root.getAttribute('data-discount-code') || '').trim();
      var codes = [];
      addons.forEach(function (a) {
        if (a.getAttribute('data-checked') !== 'true') return;
        var code = (a.getAttribute('data-addon-discount-code') || globalCode).trim();
        if (code && codes.indexOf(code) === -1) codes.push(code);
      });
      return codes;
    }

    // ============== Add to cart ==============
    function addToCart() {
      if (cta.hasAttribute('disabled')) return;
      if (!state.selectedRow) return;

      // Bygg items: vald variant + checked addons + GWP (om aktiv variant har gwp)
      var selRow = state.selectedRow;
      var qty = parseInt(selRow.getAttribute('data-quantity'), 10) || 1;
      var items = [{ id: parseInt(selRow.getAttribute('data-variant-id'), 10), quantity: qty }];

      // Prenumeration: fäst vald frekvens selling_plan på HUVUDraden (spegel av svd-lp-pren.js).
      // Engångsköp eller saknad snap → ingen selling_plan (engångsrad).
      if (state.mode === 'subscription' && state.plan) {
        items[0].selling_plan = parseInt(state.plan, 10);
      } else if (subscriptionEnabled && state.weightKey) {
        // Engångsköp: stämpla vilken plan (vikt×storlek) som SKULLE gällt – varukorgens
        // pren-nudge (svd-cart-subswap) erbjuder då exakt rätt leveransintervall.
        var swapPlan = (selRow.getAttribute('data-plan-' + state.weightKey) || '').trim();
        var swapDays = parseInt(selRow.getAttribute('data-days-' + state.weightKey), 10) || 0;
        if (swapPlan) {
          items[0].properties = { '_svd_plan': swapPlan };
          if (swapDays > 0) { items[0].properties['_svd_days'] = String(swapDays); }
        }
      }

      // Mallstyrd paketrabatt: engångsrader stämplas _godispaket = mallnamnet (Liquid
      // sätter data-paket-stamp bara när Deals Studios regel för mallen är aktiv).
      // Även 1 st stämplas, så att två separata köp slås ihop till en stämplad rad.
      var paketStamp = root.getAttribute('data-paket-stamp');
      if (paketStamp && state.mode !== 'subscription') {
        items[0].properties = items[0].properties || {};
        items[0].properties['_godispaket'] = paketStamp;
      }

      // GWP: kolla om vald variant har gwp-produkter (1–2 chips per variant)
      // Prenumerations-endast GWP: hoppa över i engångsläge.
      var selVar = state.selectedRow;
      var gwpSubOnly = root.getAttribute('data-gwp-subscription-only') === 'true';
      var gwpAllowed = !gwpSubOnly || state.mode === 'subscription';
      if (selVar && gwpAllowed) {
        var gwpEls = selVar.querySelectorAll('[data-gwp-variant-id]');
        Array.prototype.forEach.call(gwpEls, function (gwpEl) {
          var gwpId = parseInt(gwpEl.getAttribute('data-gwp-variant-id'), 10);
          if (gwpId > 0) {
            items.push({ id: gwpId, quantity: 1, properties: { '_gwp': 'true' } });
          }
        });
      }

      // Tillbehör (alltid engångsrader)
      getCheckedAddonIds().forEach(function (id) {
        items.push({ id: id, quantity: 1 });
      });

      cta.setAttribute('data-loading', 'true');
      cta.setAttribute('disabled', 'disabled');

      var discountCodes = getCheckedAddonDiscountCodes();
      var applyDiscountCode = discountCodes.length > 0;

      // Rabattkoder, väg 1 av 2 — cookien: garanterar att KASSAN får koderna.
      // VIKTIGT: måste väntas in FÖRE add-to-cart. I en färsk session
      // (t.ex. inkognito) sätter både detta anrop och varukorgsanropen
      // sessions-cookien — körs de parallellt kan varukorgens svar skriva
      // över sessionen UTAN rabatten (= rabatten saknas vid första
      // kassabesöket men dyker upp efter refresh). Serialiserat är det
      // deterministiskt. redirect:'manual' gör varje anrop snabbt (~100 ms).
      var ensureDiscountCookie = Promise.resolve();
      discountCodes.forEach(function (code) {
        ensureDiscountCookie = ensureDiscountCookie.then(function () {
          return fetch('/discount/' + encodeURIComponent(code), { redirect: 'manual', credentials: 'same-origin' })
            .catch(function (err) {
              console.warn('[svd-bundle] kunde inte sätta rabatt-cookie', code, err);
            });
        });
      });

      // Med UpCart räcker cart-bubblan — rendera inte hela drawern i onödan
      var wantedSections = hasUpCart() ? 'cart-bubble' : 'cart-drawer,cart-bubble';

      // Upsell-popup: erbjud kundens deals FÖRE köpet (om popupen finns + har deals).
      // offer() resolvar [] direkt om ingen popup / inga deals / kunden hoppar över;
      // annars de valda upsell-variant-ID:na som läggs på SAMMA /cart/add med
      // _popup_deal-flaggan (deal-priset gäller) — spegel av variant-selectorn.
      var maybeOffer = (window.SvdUpsellPopup && typeof window.SvdUpsellPopup.offer === 'function')
        ? window.SvdUpsellPopup.offer()
        : Promise.resolve([]);

      maybeOffer
        .then(function (upsellIds) {
          (upsellIds || []).forEach(function (uid) {
            var pid = parseInt(uid, 10);
            if (pid > 0) items.push({ id: pid, quantity: 1, properties: { '_popup_deal': '1' } });
          });
          return ensureDiscountCookie;
        })
        .then(function () {
          return fetch(svdRoot() + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: items,
              sections: wantedSections,
              sections_url: window.location.pathname
            })
          });
        })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e && e.description || 'Cart add failed'); });
          return res.json();
        })
        .then(function (response) {
          // Rabattkoder, väg 2 av 2 — Cart API:t: fäst koderna på själva
          // varukorgen så att rabatten kan synas redan i drawern.
          // Flera koder skickas kommaseparerade. Får aldrig blockera köpet.
          if (applyDiscountCode) {
            return fetch(svdRoot() + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({ discount: discountCodes.join(',') })
            })
              .catch(function (err) {
                console.warn('[svd-bundle] kunde inte applicera rabattkod', err);
              })
              .then(function () { return response; });
          }
          return response;
        })
        .then(function (response) {
          try { root.dispatchEvent(new CustomEvent('svd:picker:added', { bubbles: true })); } catch (e) { /* svd-kontrakt */ }
          if (hasUpCart()) {
            // UpCart fångar add-anropet och öppnar sin egen drawer —
            // uppdatera bara temats cart-bubbla, öppna INTE temats drawer.
            renderDrawerSections(response);
            tryOpenUpCart();
          } else if (document.getElementById('SvdNotis')) {
            /* SVD Notis-sektionen visar bekräftelsen (fångar /cart/add-anropet
               själv) – stanna kvar på sidan så kunden kan fortsätta handla.
               (Grenen fanns bara i v2 — därför hoppade v1-sidor direkt till
               /cart när tema-drawern inte finns. Bubblan uppdateras ändå.) */
            renderDrawerSections(response);
          } else if (!openThemeCartDrawer(response)) {
            // Inget UpCart och ingen tema-drawer: sista utväg = cart-sidan
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          console.error('[svd-bundle] add-to-cart error', err);
          alert('Något gick fel. Försök igen.');
        })
        .finally(function () {
          cta.removeAttribute('data-loading');
          renderCta();
        });
    }

    // ============== Listeners ==============
    if (weightSelect) weightSelect.addEventListener('change', onWeightChange);
    weightButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setWeight(btn.getAttribute('data-bundle-weight'));
      });
    });

    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        setMode(btn.getAttribute('data-bundle-mode'));
      });
    });

    variants.forEach(function (v) {
      v.addEventListener('click', function (e) {
        if (v.getAttribute('data-available') === 'false') {
          e.preventDefault();
          return;
        }
        var was = state.selectedRow;
        selectVariant(v);
        if (was !== v) track('paketval', 'select', { paket: Number(v.getAttribute('data-variant-index')), variant_id: v.getAttribute('data-variant-id') });
      });
      // Förhindra dubbel-trigger när man klickar direkt på radioinputen
      var radio = v.querySelector('[data-bundle-radio]');
      if (radio) {
        radio.addEventListener('change', function () {
          var was = state.selectedRow;
          selectVariant(v);
          if (was !== v) track('paketval', 'select', { paket: Number(v.getAttribute('data-variant-index')), variant_id: v.getAttribute('data-variant-id') });
        });
      }
    });

    upsells.forEach(function (b) {
      b.addEventListener('click', function () {
        var to = b.getAttribute('data-bundle-upsell-target');
        var target = variants.find(function (v) { return v.getAttribute('data-variant-index') === to; });
        if (!target || target.getAttribute('data-available') === 'false') return;
        track('upgrade_banner', 'click', { from: Number(b.getAttribute('data-bundle-upsell-for')), to: Number(to) });
        selectVariant(target);
      });
    });

    cta.addEventListener('click', addToCart);

    // Initial state — läge (prenumeration förvald om aktiverat) sätts FÖRE vikt,
    // sedan förvald viktgrupp 'w2' (mellan, 11-30 kg) så bundle inte är tomt.
    setMode(state.mode);
    setWeight('w2');
    selectVariant(state.selectedRow);
  }

  // ============== Mount all instances ==============
  function mountAll() {
    var roots = document.querySelectorAll('.svd-bundle');
    Array.prototype.forEach.call(roots, initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  // Shopify Theme Editor live preview
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:block:select', mountAll);
  /* svd-kontrakt (Claude 2026-09-25): montera väljare som injicerats i produktkortets
     "Lägg till"-blad (assets/svd-popup-quickadd.js) — bara rötter i e.detail.root. */
  document.addEventListener('svd:picker:mount', function (e) {
    var host = e && e.detail && e.detail.root;
    if (!host || !host.querySelectorAll) return;
    Array.prototype.forEach.call(host.querySelectorAll('.svd-bundle'), initBundle);
  });
})();
